import React from "react";
import HRange from "../../HRange/HRange";
import Labeled from "../Labeled";

type Props = {
    id: string;
    label: string;
    small?: string;
    min: number;
    max: number;
    step: number;
    value: number;
    onChange: (event: React.FormEvent<HTMLInputElement>) => void;
    extraClasses?: string;
};

const LabeledHRange: React.FC<Props> = (props) => {
    return (
        <Labeled id={props.id} label={props.label} small={props.small} extraClasses={props.extraClasses}>
            <HRange
                id={props.id}
                min={props.min}
                max={props.max}
                step={props.step}
                value={props.value}
                onChange={props.onChange}
            />
        </Labeled>
    );
};

export default LabeledHRange;
